import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { axiosInstance } from '../api/http'
import { useRecoilValue } from 'recoil'
import { userIdAtom } from '../state/state'

export const useContentAttempts = ({ contentId, enabled }: { contentId: number; enabled: boolean }) => {
  const userId = useRecoilValue(userIdAtom)
  const storeKey = useMemo(() => ['user', userId, 'new-content', contentId, 'attempts'], [contentId, userId])

  return useQuery(storeKey, () => axiosInstance.mobile.contentControllerGetContentAttempts(contentId), {
    enabled: !!userId && !!contentId && enabled,
    select: ({ data }) => data.payload,
  })
}
